<template>
  <tr>
    <td class="dragger">
      <img src="/img/draggable-icon.png" />
    </td>
    <td>
      <select-field
        class="input-sm"
        :id="`amount-${position}-chapter-id`"
        :name="`amount[${position}][chapterId]`"
        :value="variant.chapterId || ''"
        :items="availableChapters"
        @selected="
          (name, chapterId) => $emit('chapterSelected', variant.id, chapterId)
        "
      />
    </td>
    <td>
      <select-field
        class="input-sm"
        :id="`amount-${position}-category-id`"
        :name="`amount[${position}][categoryId]`"
        :value="variant.categoryId || ''"
        :items="availableCategories"
      />
    </td>
    <td
      v-for="currency in currencies"
      :key="`amount-${position}-${currency.code}`"
    >
      <price-amount
        :name="`amount[${position}][amounts][${currency.code}]`"
        :amount="variant['amounts'][currency.code] || ''"
        :currency="currency"
      />
    </td>
    <td>
      <a href @click.prevent="$emit('deleted', variant)">
        <icon name="close-circle" />
      </a>
    </td>
  </tr>
</template>

<script>
import { SelectField } from 'vue-bootstrap';
import Icon from '@/lib/components/Shared/Icon';
import PriceAmount from './PriceAmount';

export default {
  inject: ['lang'],
  components: {
    Icon,
    PriceAmount,
    SelectField
  },
  props: {
    variant: {
      type: Object,
      default: () => ({})
    },
    position: {
      type: Number,
      default: 0
    },
    currencies: {
      type: Array,
      default: () => []
    },
    chapters: {
      type: Array,
      default: () => []
    },
    categories: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    availableChapters() {
      const allChapters = {
        id: '',
        name: this.lang.get('payments.prices.amount_selectors.chapters')
      };

      return [allChapters, ...this.chapters];
    },
    availableCategories() {
      const allCategories = {
        id: '',
        name: this.lang.get('payments.prices.amount_selectors.categories')
      };

      if (this.variant.chapterId) {
        return [
          allCategories,
          ...this.categories.filter(category =>
            category.chapterIds.includes(this.variant.chapterId)
          )
        ];
      }

      return [allCategories, ...this.categories];
    }
  }
};
</script>
